import AbstractSettings from "../shared/AbstractSettings";

export default class Settings extends AbstractSettings { }
